import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { TokenServiceService } from './token-service.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
    token: string;
    state: string;
    route: string;
    refID: string;
    journeyType: string;
    constructor(private tokenService: TokenServiceService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // this.tokenService.selectedstateCode.subscribe(token => {
        //     this.token = token
        //     console.log(this.token)
        // })
        // this.token = sessionStorage.getItem('wEnlw3OeU3')
        // if (this.token) {
        //     console.log(this.token)
        //     const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token) });
        //     return next.handle(tokenizedReq);
        // }
        // debugger
        var kccToken = this.tokenService.getKccToken();
        if (kccToken) {
            console.log("kcc-token attached to:", req.url);
            req = req.clone({ headers: req.headers.set('kcc-token', kccToken) });
        }
        this.token = sessionStorage.getItem('wEnlw3OeU3')
        this.route = sessionStorage.getItem('rtItemPath')
        this.refID = sessionStorage.getItem('referenceId')
        this.journeyType = sessionStorage.getItem('freshORresume');
        console.log("State-",this.token, "Fresh or Renewal-",this.route, "ReferenceID-",this.refID, "Journey type",this.journeyType)
        if(this.journeyType){
            let journeyToken = ""
            this.journeyType == "fresh"?journeyToken = "F4F8875DD58AD": this.journeyType == "resume"?journeyToken = "RE1848BAE511B":"";
            if (this.token && this.refID) {
                if(this.route == "axdcmqihn"){
                    console.log(this.token)
                    const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','rx9U2r9MOQYqMNbuew1ARfmxinKfakBa').set('referenceId',this.refID).set('res-fresh-token',journeyToken).set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx') });
                    return next.handle(tokenizedReq);
                }else if(this.route == "ftrwrefsh"){
                    console.log(this.token)
                    const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','fEX2MF2z6zLvvWDu9t1JSLVhKxqiRIqv').set('referenceId',this.refID).set('res-fresh-token',journeyToken).set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx') });
                    return next.handle(tokenizedReq);
                }
    
            }else if(this.token && !this.refID){
                if(this.route == "axdcmqihn"){
                    console.log(this.token)
                    const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','rx9U2r9MOQYqMNbuew1ARfmxinKfakBa').set('res-fresh-token',journeyToken).set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx') });
                    return next.handle(tokenizedReq);
                }else if(this.route == "ftrwrefsh"){
                    console.log(this.token)
                    const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','fEX2MF2z6zLvvWDu9t1JSLVhKxqiRIqv').set('res-fresh-token',journeyToken).set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx') });
                    return next.handle(tokenizedReq);
                }
            }else if(this.refID){
    
                    console.log(this.token)
                    const tokenizedReq = req.clone({ headers: req.headers.set('referenceId', this.refID).set('res-fresh-token',journeyToken).set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx') });
                    return next.handle(tokenizedReq);
    
            }else{
                console.log(this.token)
                const tokenizedReq = req.clone({ headers: req.headers.set('res-fresh-token',journeyToken).set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx') });
                return next.handle(tokenizedReq);
            }
        }else{
            if(this.route){
                if(this.route == "axdcmqihn"){
                    console.log(this.token);
                    if(!this.token){
                        debugger
                    }
                    const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','rx9U2r9MOQYqMNbuew1ARfmxinKfakBa').set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx')});
                    return next.handle(tokenizedReq);
                }else if(this.route == "ftrwrefsh"){
                    console.log(this.token)
                    const tokenizedReq = req.clone({ headers: req.headers.set('route-api-key', this.token).set('fr-re-token-api-route','fEX2MF2z6zLvvWDu9t1JSLVhKxqiRIqv').set('source-api-key','WsIjB6vsrdYYl615c1EarEG48d8n1CSx')});
                    return next.handle(tokenizedReq);
                }
            }
        }


        return next.handle(req);
    }
}